import { useFeatureFlag } from '@/hooks/use-feature-flag';

import { CardNbAlerts } from './card-nb-alerts';
import { CardTasks } from './card-tasks';
import { CardTrippedSystem } from './card-tripped-systems';
import { CardWhiteLabelNbTickets } from './card-white-label-nb-tickets';
import { SitesDetailsHero } from './sites-details-hero';

export function WhiteLabelSitesDetails() {
  const featureFlag = useFeatureFlag();

  return (
    <div data-testid="sites-details" className="flex flex-col gap-4">
      <div className="">
        <SitesDetailsHero />
      </div>
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
        <CardTrippedSystem />
        {featureFlag('alerts') ? <CardNbAlerts /> : null}
        <CardTasks />
        <CardWhiteLabelNbTickets />
      </div>
    </div>
  );
}
